import { render, staticRenderFns } from "./BonesOpacity.vue?vue&type=template&id=45294857&scoped=true&"
import script from "./BonesOpacity.vue?vue&type=script&lang=js&"
export * from "./BonesOpacity.vue?vue&type=script&lang=js&"
import style0 from "./BonesOpacity.vue?vue&type=style&index=0&id=45294857&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45294857",
  null
  
)

export default component.exports